import React from "react"

// Small navy line icons for the Center Info rows.
// Inline SVG (rather than the old white PNGs) so they stay legible on the
// light card background and can be recoloured from CSS.

const base = {
  className: "ClinicInfo__icon",
  fill: "currentColor",
  viewBox: "0 0 24 24",
  "aria-hidden": "true",
}

export const PinIcon = () => (
  <svg {...base}>
    <path d="M12 2a7 7 0 0 0-7 7c0 5.25 7 13 7 13s7-7.75 7-13a7 7 0 0 0-7-7Zm0 9.5A2.5 2.5 0 1 1 12 6.5a2.5 2.5 0 0 1 0 5Z" />
  </svg>
)

export const PhoneIcon = () => (
  <svg {...base}>
    <path d="M6.6 10.8a15.1 15.1 0 0 0 6.6 6.6l2.2-2.2c.3-.3.7-.4 1-.2 1.2.4 2.4.6 3.6.6.6 0 1 .4 1 1V20c0 .6-.4 1-1 1A17 17 0 0 1 3 4c0-.6.4-1 1-1h3.5c.6 0 1 .4 1 1 0 1.3.2 2.5.6 3.6.1.4 0 .8-.2 1l-2.3 2.2Z" />
  </svg>
)

export const FaxIcon = () => (
  <svg {...base}>
    <path d="M19 8h-1V3H6v5H5a3 3 0 0 0-3 3v6h4v3h12v-3h4v-6a3 3 0 0 0-3-3ZM8 5h8v3H8V5Zm8 14H8v-4h8v4Zm3-7.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z" />
  </svg>
)
